var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDownloadGray(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.2,
    height: 16,
    viewBox: "0 0 19.2 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#707070;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -2)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M10.8,13.2a.6.6,0,0,1-.434-.186l-4.2-4.4A.6.6,0,0,1,6.6,7.6H8.8V3a1,1,0,0,1,1-1h2a1,1,0,0,1,1,1V7.6H15a.6.6,0,0,1,.434,1.014l-4.2,4.4A.6.6,0,0,1,10.8,13.2Z",
    transform: "translate(-1.2)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M17.8,21.2H1.4A1.4,1.4,0,0,1,0,19.8v-.4A1.4,1.4,0,0,1,1.4,18H17.8a1.4,1.4,0,0,1,1.4,1.4v.4A1.4,1.4,0,0,1,17.8,21.2Z",
    transform: "translate(0 -3.2)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadGray);
export default __webpack_public_path__ + "static/media/download-gray.dea784c0a129d5c75d4958abdb3cb31b.svg";
export { ForwardRef as ReactComponent };